import React, { useState, useEffect, useRef } from "react";

import moment from "moment";
import { Link, useHistory } from "react-router-dom";

import { columnsCsv } from "./blocklistcontent";
import { options } from "./blocklistcontent";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../../common/notification-message/notification";

import {
  getBlockList,
  getDeleteBlocklist,
  saveBlocklist,
  searchBlocklist,
} from "./../manageuserVerification/utils";
import { blocklistdata } from "../manageuserVerification/mockdata";
import BlockListheader from "./blocklistheader";
import { getDropdownCountryList } from "../../../service/rak-beneficiary-service";
const BlockList = () => {
  const history = useHistory();
  const [searchBy, setSearchBy] = useState("Card Serial Number");
  const request = {
    page: 1,
    size: 10,
    createdDate: "",
    identifier: "",
    lastFailedAttemptTimeStamp: "",
    isActive: "",
    type: searchBy,
    fromDate: "",
    toDate: "",
    searchFilter: "",
    countryCode: "",
  };
  const request1 = {
    type: "",
    identificationNumber: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [filterForm1, setFilterForm1] = useState(request1);
  const [modalShow, setModalShow] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState();
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [adminStatus, setAdminStatus] = useState(false);
  const [superadminStatus, setSuperadminStatus] = useState(false);
  const [callcentreagentStatus, setCallcentreagentStatus] = useState(false);
  const [customerserviceStatus, setCustomerserviceStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  // const [selectedOption, setSelectedOption] = useState("");
  const [blockList, setblockList] = useState([]);
  const [Selectedrow, setSelectedrow] = useState();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchdataLoading, setSearchDataLoading] = useState(false);
  const [blockListExcel, setblockListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");
  const [modal, setmodal] = useState(false);
  const [type, setType] = useState([]);
  const [identyId, setIdentyId] = useState("");
  const [searchblockList, setsearchblockList] = useState([]);
  const [blockbutton, setBlockbutton] = useState(false);
  const [country, setCountry] = useState({
    searchedCountry: "",
    selectedCountry: [],
  });
  const [countryList, setCountryList] = useState([]);
  const disableStyle = {
    color: "#ddd",
    width: "25px",
    height: "15px",
    cursor: "not-allowed",
  };
  const activeStyle = {
    width: "25px",
    height: "15px",
    cursor: "pointer",
  };
  useEffect(() => {
    getDropdownAllCountryList();
  }, []);

  const getDropdownAllCountryList = () => {
    //   api calls for country:
    getDropdownCountryList("ALL")
      .then((getDropdownCountryListRes) => {
        if (getDropdownCountryListRes && getDropdownCountryListRes.data) {
          let data = getDropdownCountryListRes.data.map((element) => {
            element.label = element.name || "";
            element.value = element.code || "";
            return element;
          });
          setCountryList(data);
        }
      })
      .catch((getDropdownCountryListErr) => {
        setCountryList([]);
      });
  };

  const columns = [
    {
      dataField: "action",
      text: "Action",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <div>
            <i
              // style={{ fontSize: 18 }}
              className="fas fa-trash-alt"
              style={
                row.entityType === "Card Serial Number"
                  ? activeStyle
                  : disableStyle
              }
              onClick={() => {
                if (row.entityType === "Card Serial Number") {
                  if (row && row.id) {
                    setSelectedrow(row.id);
                  }
                  setModalShow(true);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "created Date",
      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "identifier",
      text: "Identifier",
      headerStyle: { textAlign: "center" },
      style: { minWidth: "80px", textAlign: "center" },
    },
    {
      dataField: "countryCode",
      text: "Country Code",
      headerStyle: { textAlign: "center" },
      style: { minWidth: "80px", textAlign: "center" },
    },
    {
      dataField: "entityType",
      text: "Entity Type",
      headerStyle: { textAlign: "center" },
      style: { minWidth: "80px", textAlign: "center" },
    },
    {
      dataField: "lastFailedAttemptTimeStamp",
      text: "Last Failed Attempt Date ",

      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
      formatter: (cell, row) => {
        return row && row.lastFailedAttemptTimeStamp
          ? moment(row.lastFailedAttemptTimeStamp).format("DD-MM-YY HH:mm:ss")
          : null;
      },
    },
  ];

  const rowClicked = (data) => {
    let states = { ...data };

    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.id, rowData: states },
    });
  };

  useEffect(() => {
    if (filterForm) {
      getblocks(filterForm);
    }
  }, [filterForm]);

  // delete api
  const onDelete = () => {
    setDeleteLoader(true);
    getDeleteBlocklist(Selectedrow)
      .then((res) => {
        setModalShow(false);
        setDeleteLoader(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Delete Successfully"
        );

        getblocks(filterForm);
      })
      .catch((err) => {
        setModalShow(false);
        openNotificationWithIcon(
          notificationStrings.error,
          "Something Went Wrong"
        );
        setDeleteLoader(false);
      });
  };

  // blocklist api
  const getblocks = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getBlockList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.blackLists.length > 0) {
          setblockList(res.data.blackLists);
        } else {
          setblockList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 10, current: 1 });
        setDataLoading(false);
        setblockList(blocklistdata);
      });
  };

  const resetFilter = () => {
    setSearchBy("Card Serial Number");
    // setSearchByValue('');
    setFiltersSelected(false);
    setblockList([]);
    setblockListExcel([]);
    setFromDate("");
    setToDate("");
    // setSelectedOption("");
    setFilterValues(false);
    setSearchByValue("");
    setFilterForm(request);
    setCountry({ ...country, searchedCountry: "" });
  };
  const handleSearch = () => {
    let request = {};
    request = {
      ...filterForm,
      identifier: searchByValue,
      createdDate: "",
      type: searchBy,
    };
    request.countryCode = country.searchedCountry || "";
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;

    request.page = 1;
    // request.searchFilter = a;
    // TODO - NEED TO REMOVE
    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "Card Serial Number") {
    searchByValuePlaceholder = "1234567890";
  }
  if (searchBy === "Mobile Recharge Phone Number") {
    searchByValuePlaceholder = "97150123456789";
  }
  if (searchBy === "Money Transfer Account Number") {
    searchByValuePlaceholder = "17559879157312471";
  }

  const handleReset = () => {
    setblockList();
    setSearchByValue("");
  };
  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getBlockList(request)
      .then((res) => {
        if (res && res.data && res.data.blackLists.length > 0) {
          let data = res.data.blackLists.map((element) => {
            if (element.createdDate) {
              element.createdDate = moment(element.createdDate).format(
                "DD-MM-YYYY"
              );
            }
            return element;
          });
          setblockListExcel(() => data);
          buttonRef.current.click();
        } else {
          setblockListExcel([]);
        }
      })
      .catch((err) => {
        setblockListExcel([]);
      });
  };
  const handlesearchBlocklist = () => {
    let request = {};
    request.type = type[0].value;
    request.countryCode = country.selectedCountry[0].value;
    request.identificationNumber = identyId;
    setSearchDataLoading(true);
    searchBlocklist(request)
      .then((res) => {
        setBlockbutton(true);
        setSearchDataLoading(false);
        if (res && res.data && res.data.length > 0) {
          setsearchblockList(res.data);
        }
      })
      .catch((err) => {
        setsearchblockList([]);
        setSearchDataLoading(false);
        setBlockbutton(true);
      });
  };
  const handlesaveBlocklist = () => {
    let request = {};
    request.type = type[0].value;
    request.countryCode = country.selectedCountry[0].value;
    request.identificationNumber = identyId;
    setSearchDataLoading(true);
    saveBlocklist(request)
      .then((res) => {
        setSearchDataLoading(false);
        setmodal(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Blocked Successfully"
        );
        setBlockbutton(false);
        getblocks(filterForm);
        setsearchblockList([]);
        setType(() => []);
        setIdentyId(() => "");
        setCountry({ ...country, selectedCountry: [] });
      })
      .catch((err) => {
        setSearchDataLoading(false);
        setmodal(false);
        setsearchblockList([]);
        setBlockbutton(false);
        setType(() => []);
        setIdentyId(() => "");
        setCountry({ ...country, selectedCountry: [] });
      });
  };

  return (
    <BlockListheader
      searchdataLoading={searchdataLoading}
      setType={setType}
      handlesaveBlocklist={handlesaveBlocklist}
      setIdentyId={setIdentyId}
      type={type}
      identyId={identyId}
      setmodal={setmodal}
      setBlockbutton={setBlockbutton}
      blockbutton={blockbutton}
      handlesearchBlocklist={handlesearchBlocklist}
      modal={modal}
      searchBy={searchBy}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      setModalShow={setModalShow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      deleteLoader={deleteLoader}
      filterValues={filterValues}
      blockList={blockList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      blockListExcel={blockListExcel}
      columns={columns}
      onDelete={onDelete}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      // handleChange={handleChange}
      options={options}
      // selectedOption={selectedOption}
      handleSearch={handleSearch}
      handleReset={handleReset}
      searchblockList={searchblockList}
      country={country}
      setCountry={setCountry}
      countryList={countryList}
    />
  );
};

export default BlockList;
